export enum LOCAL_STORE_KEYS {
    PAGE_STATES = 'page-status'
}

export enum PAGE_STATES {
    LOADING = 'loading',
    MUTATE = 'mutate'
}